import { useUBL } from '@common/log-manager';
import { getSizeRecommendObjectId, PdpProductSizeType } from '@domains/pdp-common';

export const useLegacySizeRecommendationUBL = () => {
  const sendUBL = useUBL();

  const sizeRecommendationImpression = ({
    recommendationType,
    recommendOptionValueList,
    catalogProductId,
  }: {
    recommendationType: PdpProductSizeType;
    recommendOptionValueList: Array<{ ranking: number; name: string }>;
    catalogProductId: string;
  }) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_section: 'size_recommend',
      object_type: 'section',
      object_id: getSizeRecommendObjectId(recommendationType),
      ...(recommendationType !== PdpProductSizeType.NONE && {
        data: {
          catalog_product_id: catalogProductId,
          recommendation_type: recommendationType,
          option_value_list: recommendOptionValueList,
        },
      }),
    });
  };

  const inputBodyInfoClick = () => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'size_recommend',
      object_type: 'button',
      object_id: 'input_body_info',
    });
  };

  return {
    sizeRecommendationImpression,
    inputBodyInfoClick,
  };
};
